import * as React from "react";
import { Spinner } from "components/common";
import { useAllEventDefinitions } from "components/event-definitions/hooks/useEventDefinitions";
import CorrelationForm from "event-correlation/CorrelationForm";
import SigmaCorrelationLicenseStatus from "./SigmaCorrelationLicenseStatus";
import useSigmaCorrelationLicenseStatus from "./hooks/useSigmaCorrelationLicenseStatus";
const SigmaCorrelationFormContainer = (props) => {
  const licenseStatus = useSigmaCorrelationLicenseStatus();
  const { data } = useAllEventDefinitions();
  const eventDefinitions = data == null ? void 0 : data.event_definitions;
  if (!eventDefinitions || licenseStatus.loading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Event Definitions..." });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SigmaCorrelationLicenseStatus, { licenseStatus }), /* @__PURE__ */ React.createElement(CorrelationForm, { ...props, eventDefinitions }));
};
export default SigmaCorrelationFormContainer;
